import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EnrollOrderLayer from "../components/EnrollOrderLayer";

const EnrolOrderPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Enroll New Order' />

        {/* BlogLayer */}
        <EnrollOrderLayer />
      </MasterLayout>
    </>
  );
};

export default EnrolOrderPage;
